/**
 * f.userInfo.processConfig场景入参值
 * 授信、用信、预授信 各场景
 */
export enum VerifyTypeEnum {
  /** 授信-前置检验: ocr、活体 */
  FIRST_INFO = 'firstInfo',
  /** 授信-后置资料补充：个人信息、联系人(以及兜底前置校验) */
  ADD_INFO = 'addInfo',
  /** 授信-前置核验 (ocr后置流程) */
  FIRST_INFO_OCR_AFTER = 'firstInfoOcrAfter',
  /** 预授信-前置1步检验 */
  PRE_CREDIT_FIRST_INFO = 'preCreditFirstInfo',
  /** 预授信-后置3步检验 */
  PRE_CREDIT_ADD_INFO = 'preCreditAddInfo',
  /** 仅身份证流程 */
  ONLY_ID_CARD = 'onlyIdCard',
  /** 二要素核验: 姓名、身份证号 */
  TWO_ELEMENTS = 'nameAndIdCardNo',
}

export interface UserInfoProcessConfig {
  /** 用户资料填写进度(0, 90, 100) */
  activationProgress?: number;
  /** 当前页面(userBase、contactInfo、idCard、bioAuth) */
  currentPage?: string;
  /** 是否最后一页 */
  isLast?: boolean;
  /** 本阶段资料是否都填完 */
  infoComplete: boolean;
  /** 是否是OCR后置流程 */
  ocrAfter?: boolean;
  /** 是否ocr照片完整 */
  ocrComplete?: boolean;
}

export interface CreditTaskProduct {
  productId: string;
}
